<script>
    import hosted from '../private/hosted';

    /**
     * This is a modeless bubble that is anchored to an element in the underlying view. It accepts
     * recommendations for position and alignment but will position itself as necessary to stay in
     * view. If the anchor goes out of view or is obscured, the popup will be hidden. The anchor
     * can be specified simply by putting it in the `anchor` slot, or via the `anchor` prop as an
     * Element.
     */
    export default {
        name: 'ib-popup',

        mixins: [
            hosted
        ],

        inheritAttrs: false,

        props: {
            /**
             * Requested position relative to window [top, right, bottom, left, start, end].
             */
            position: {
                type: String,
                default: 'top'
            },
            /**
             * Alignment relative to anchor [start, center, end, grow, left, right]; default is start.
             * This is advisory and alignment can change to accommodate screen space.
             */
            align: {
                type: String,
                default: 'center'
            },
            /**
             * Shadow elevation [0..16].
             */
            elevation: Number,
            /**
             * Element to anchor to. This is an alternative to using the `anchor` slot.
             */
            anchor: Element,
            /**
             * Width in any CSS units.
             */
            width: String,
            /**
             * Height in any CSS units.
             */
            height: String
        },

        render(h) {
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._pop {
        position: fixed;
    }
</style>
